import React, { useState } from 'react';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import { validate as validatePhoneNumber } from '../../../components/PhoneNumberValidation/PhoneNumberValidation';
import { Formik, Form } from 'formik';
import Toast from '../Toast/Toast';
import { getAddBPApi } from '../../../common/constants/api';
import * as Yup from 'yup';
import { navigate } from 'gatsby';

const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Please enter email address')
    .max(50, 'Email adress is Too Long!')
    .required('Required')
    .matches(
      /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
      'invalid type'
    ),
  mobile: Yup.string()
    .required('Required')
    .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number')
});

const AddBP = ({ setShow }) => {
  const [error, setError] = useState('');
  async function getAddBP(values) {
    const res = await getAddBPApi(values);
    if (!res.isAxiosError) {
      setShow(false);
      Toast('success', 'invitation has been sent', 3000, 'top-center');
      navigate('/app/dashboard');
    }
    if (res.isAxiosError) {
      setError(res.data);
    } else {
      setError('');
    }
  }

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        mobile: '',
        email: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => {
        return (
          <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="pt-2 sm:px-5 "
          >
            <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
              <CommonInput
                name="firstName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
                stylesContainer={{
                  maxWidth: '100%'
                }}
                legendName="First Name"
                error={touched.firstName && errors.firstName}
                errorMsg={errors.firstName}
                touched={touched.firstName}
              />
            </div>

            <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
              <CommonInput
                name="lastName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastName}
                stylesContainer={{
                  maxWidth: '100%'
                }}
                legendName="Last Name"
                error={touched.lastName && errors.lastName}
                errorMsg={errors.lastName}
                touched={touched.lastName}
              />
            </div>

            <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
              <CommonInput
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                stylesContainer={{
                  maxWidth: '100%'
                }}
                error={touched.email && errors.email}
                errorMsg={errors.email}
                legendName="Email"
                touched={touched.email}
              />
            </div>

            <div className="relative mb-4 mb-10">
              <div
                style={{ marginTop: '17px' }}
                className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
              >
                +91
              </div>
              <div className="font-normal font-roboto text-sm text-black-500 ">
                <CommonInput
                  name="mobile"
                  maxLength={10}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.mobile}
                  stylesContainer={{
                    maxWidth: '100%'
                  }}
                  inputStyle={{
                    paddingLeft: '45px',
                    letterSpacing: '1px'
                  }}
                  onBlurStyle={{
                    paddingLeft: '20px'
                  }}
                  legendStyle={{
                    paddingLeft: errors.mobile ? '20px' : '20px'
                  }}
                  legendName="Mobile Number"
                  error={touched.mobile && errors.mobile}
                  //errorMsg={errors.mobile}
                  className={`pt-24`}
                  touched={touched.mobile}
                  errorMsg={errors.mobile}
                  onKeyPress={e => {
                    validatePhoneNumber(e, values.mobile.length);
                  }}
                />
              </div>
            </div>
            <div className="my-6">
              <button
                onClick={() => {
                  getAddBP(values);
                }}
                id="submit"
                className="submitButton  uppercase  w-56"
                type="submit"
                disabled={
                  values.mobile == '' ||
                  values.email == '' ||
                  errors.mobile ||
                  errors.email
                }
              >
                ADD
              </button>
              {error && <div className="text-red-200 mt-3">{error}</div>}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddBP;
